export default "__VITE_ASSET__CCh40912__"